import api from '@/api/fyApi';
import BaseModule from "@/common/BaseModule";
import { Module } from "vuex";
import { LOAD_CHANNELS_MOVIE, SEO, LOAD_MINE_FAVORITES, LOAD_CHANNELS_ROOT } from "../protocols";

export interface State {
    detail?: MovieAlbumDetail,
    id: number,
    isFavorite: boolean,
    pageIndex: number,
    pageSize: number,
    pages: number[],
}

class MovieAlbums extends BaseModule<State> {
    constructor() {
        super(LOAD_CHANNELS_MOVIE[0])
    }

    generate(): Module<State, any> {
        return {
            namespaced: true,
            state: {
                id: 0,
                isFavorite: false,
                pageIndex: 0,
                pageSize: 20,
                pages: [],
            },
            mutations: {
                updateId(state, value) {
                    state.id = value
                    state.isFavorite = false
                },
                updateDetail(state, data) {
                    state.detail = data
                    let arr: number[] = []
                    let total = Math.ceil(data.url_list.length / state.pageSize)
                    for (let i = 0; i < total; i++) {
                        arr.push(i)
                    }
                    state.pages = arr
                    state.pageIndex = data.listsort == 1 ? arr.length - 1 : 0
                }
            },
            actions: {
                async refreshFavorite({ state, rootState }) {
                    if (state.id > 0) {
                        state.isFavorite = rootState[LOAD_MINE_FAVORITES[0]].list.some((item: any) => item.movid == state.id)
                    }
                },
                async loadDetail({ commit, rootState, state }, { params }: Route) {
                    let id = parseInt(params.id)
                    commit('updateId', id)
                    state.isFavorite = rootState[LOAD_MINE_FAVORITES[0]].list.some((item: any) => item.movid == id)
                    let result = await api.getMovieAlbum(id)
                    commit('updateDetail', result)
                    api.postHit('movie', id)
                    const seoTitle = result.title + '-专辑-频道-福音影视网|福音TV'
                    commit('updateSeo', Object.assign({}, SEO, { title: seoTitle }), { root: true })
                },
                [LOAD_CHANNELS_MOVIE[1]]({ dispatch, commit }, route: Route) {
                    const seoTitle = '专辑-频道-福音影视网|福音TV'
                    commit('updateSeo', Object.assign({}, SEO, { title: seoTitle }), { root: true })
                    return Promise.all([
                        dispatch(LOAD_CHANNELS_ROOT[0] + '/loadLeft', {}, { root: true }),
                        dispatch('loadDetail', route),
                    ])
                }
            }
        }
    }
}

export default new MovieAlbums()